import React, { memo } from 'react';
import { useParams } from 'react-router-dom';

import ListContainer from './ListContainer';
import DetailContainer from './DetailContainer';

const Container = memo(() => {
  const { id } = useParams<{ id: string }>();

  return id && id !== 'mine' ? (
    <DetailContainer id={id} />
  ) : (
    <ListContainer isMine={id === 'mine'} />
  );
});

export default Container;

export * from './components';
